<template>
  <div>
    <div v-if="couponList && couponList.length > 0" class="coupon-box">
        <div
            v-for="coupon in couponList" 
            :key="coupon.id" 
        >
            <div class="coupon coupon-wave-left coupon-wave-right" :class="{ 'coupon-yellow-gradient' : coupon.usageStatus === '0',  'coupon-grey-gradient' : coupon.usageStatus === '1'}">
                <div class="coupon-info coupon-info-right-dashed">
                    <div class="coupon-store" style="font-weight: 700;font-size:15px;">No.{{ coupon.couponNumber }}</div>
                    <div class="coupon-price" style="text-align: center;">${{ coupon.amount }}<span></span></div>
                    <div class="coupon-expiry-date" style="font-weight: 600;font-size:15px;text-align: center;">{{ dateFormatB(coupon.createDate) }}</div>
                </div>
                <div class="coupon-get">
                    <div class="coupon-desc">
                    <div v-if="coupon.usageStatus === '0'" style="text-align: center;" >
                        <div>Available</div>
                    </div>
                    <div v-else style="text-align: center;">Used</div>
                    </div>
                    <div v-if="coupon.usageStatus === '1'" class="coupon-expiry-date" style="font-weight: 600;font-size:15px;text-align: center;">
                        <span v-if="coupon.usageStatus === '1'">{{ dateFormatB(coupon.usageTime) }}</span><br>
                        <span v-if="coupon.usageStatus === '1' && coupon.bookingNumber">{{ coupon.bookingNumber }}</span>
                    </div>
                </div>
            </div>
            <!-- ROLE_SYS-->
            <div style="margin-left: 15px;" v-if="$auth('ROLE_CDB_SENIOR')">
                <coupon-recover @couponChange="handleCouponChange" :coupon="coupon"></coupon-recover>
            </div>
        </div>
    </div>
    <div v-else style="margin-top:20px;">
        <div style="font-size:16px;line-height: 30px;">
            Sorry! You don't have a coupon right now!
        </div>
    </div>
  </div>
</template>

<script>
import CouponRecover from './CouponRecover'

export default {
  name: 'MembershipCouponList',
  components: {
      CouponRecover
  },
  props: {
    initData: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      couponList: null
    }
  },
  mounted () {
      this.loadData(this.initData)
  },
  methods: {
    async loadData (data) {
        this.couponList = data
    },
    // 处理coupon状态变化
    handleCouponChange (newCoupon) {
        const couponList = this.couponList
        if (couponList && couponList.length > 0) {
            for(let i=0; i< couponList.length; i++) {
                const coupon = couponList[i]
                if (coupon.couponNumber === newCoupon.couponNumber) {
                    this.$set(this.couponList, i, newCoupon)
                }
            }
        }
        this.$emit('couponChange', newCoupon)
    },
  },
  watch: {
    initData (newValue) {
      this.loadData(newValue)
    }
  }
}
</script>

<style scoped>
body {
    display: flex;
    flex-wrap: wrap;
}
.coupon {
    display: inline-flex;
    color: white;
    position: relative;
    padding-left: .5rem;
    padding-right: .5rem;
    margin: 1rem;
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
    overflow: hidden;
}
.coupon-yellow {
    background-color: #F39B00;
}
.coupon-grey-gradient {
    background-image: linear-gradient(150deg, #CCCCCC 50%, #DDDDDD 50%);
    color: #666;
    min-width: 125px;
}
.coupon-yellow-gradient {
    background-image: linear-gradient(150deg, #F39B00 50%, #F39B00D8 50%);
    min-width: 127px;
}
.coupon-blue-gradient {
    background-image: linear-gradient(150deg, #50ADD3 50%, #50ADD3D8 50%);
}
/** 左边框波浪 **/
.coupon-wave-left::before, .coupon-wave-right::after{
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    width: 14px;
    background-image: radial-gradient(white 0, white 4px, transparent 4px);
    /** 若只设置为r（半径）的两倍(直径)，则半圆之间没有类似堤岸的间隔 */
    background-size: 14px 14px;
    background-position: 0 2px;
    background-repeat: repeat-y;
    z-index: 1;
}
.coupon-wave-left::before {
    left: -7px;
}
.coupon-wave-right::after {
    right: -7px;
}
.coupon-info {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.7rem;
    position: relative;
   /*  min-width: 15rem; */
   min-width: 200px;
}
.coupon-info-right-dashed {
    border-right: 2px dashed white;
}
.coupon-info-right-solid {
    border-right: 2px solid white;
}
/** 使用两个边框为圆角的白色div制造半圆缺角，有个缺点是这个缺角必须与背景色相同（clip-path不好使用） **/
.coupon-hole::before, .coupon-hole::after {
    content: '';
    width: 1rem;
    height: 1rem;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    right: -.5rem;
}
.coupon-info::before {
    top: -.5rem;
}
.coupon-info::after {
    bottom: -.5rem;
}
.coupon-info>div {
    margin-bottom: .2rem;
}
.coupon-price {
    font-size: 250%;
    font-weight: bold;
}
.coupon-price>span {
    font-size: 40%;
    margin-left: .5rem;
    font-weight: normal;
}
.coupon-get {
    padding: 1rem;
    /** 这里使用flex是为了让文字居中 */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-width: 110px;
    position: relative;
}
.coupon-get>.coupon-desc {
    font-size: 150%;
    margin-bottom: .5rem;
    font-weight: bold;
}
.coupon-get-already::after {
    content: '';
    width: 5rem;
    height: 5rem;
    background-size: 5rem 5rem;
    background-image: url('data:image/png;base64,iVBORw0I=');
    position: absolute;
    top: -1rem;
    right: -1rem;
}
</style>